import { ResponsiveBlockSwitcher } from "@/shared/Components";
import { ActivitiesDesktop, ActivitiesMobile } from "./components";

export const ActivitiesTabContent = () => {
  return <ResponsiveBlockSwitcher desktop={<ActivitiesDesktop />} mobile={<ActivitiesMobile />} />;
};
